export default function PHP_Modify_Strings() {
  return (
    <div>
      <h1>PHP_Modify_Strings</h1>
    </div>
  );
}
